// extracted by mini-css-extract-plugin
export default {"QualityDetailsNCRs_chartTitle":"BreakdownChart_QualityDetailsNCRs_chartTitle__OHOIc"};